"use client";

import { useSessionSync } from "@/lib/hooks/useSessionSync";

export default function SessionSync() {
  useSessionSync();
  return null;
}

